var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 4.5C6.72998 4.54 1.69998 9.66 1.73998 15.92C1.77998 22.18 1.73998 15.92 1.73998 15.92V17.99C1.73998 18.81 2.40998 19.49 3.23998 19.49H22.74C23.56 19.49 24.24 18.81 24.24 17.99V15.91V15.909C24.28 9.649 19.24 4.529 12.99 4.489L13 4.5Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.5V18.75C10 17.09 11.34 15.75 13 15.75C14.65 15.75 16 17.09 16 18.75V19.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 9L13 15.75",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 15C4.385 15 4 15.3733 4 15.875C4 16.3417 4.37333 16.75 4.875 16.75C5.34167 16.75 5.75 16.3533 5.75 15.875C5.75 15.385 5.35333 15 4.875 15Z",
    stroke: "none",
    className: "fill-also"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 10C6.385 10 6 10.3733 6 10.875C6 11.3417 6.37333 11.75 6.875 11.75C7.34167 11.75 7.75 11.3533 7.75 10.875C7.75 10.385 7.35333 10 6.875 10Z",
    stroke: "none",
    className: "fill-also"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 15C20.135 15 19.75 15.3733 19.75 15.875C19.75 16.3417 20.1233 16.75 20.625 16.75C21.0917 16.75 21.5 16.3533 21.5 15.875C21.5 15.385 21.1033 15 20.625 15Z",
    stroke: "none",
    className: "fill-also"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 10.253C18.635 10.253 18.25 10.6263 18.25 11.128C18.25 11.5947 18.6233 12.003 19.125 12.003C19.5917 12.003 20 11.6063 20 11.128C20 10.638 19.6033 10.253 19.125 10.253Z",
    stroke: "none",
    className: "fill-also"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.87 7.253C10.38 7.253 9.995 7.62633 9.995 8.128C9.995 8.59466 10.3683 9.003 10.87 9.003C11.3367 9.003 11.745 8.60633 11.745 8.128C11.745 7.638 11.3483 7.253 10.87 7.253Z",
    stroke: "none",
    className: "fill-also"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.63d33cfffea87fefc3c53325b582e47a.svg";
export { ForwardRef as ReactComponent };